import { ErrorCode } from 'src/constants';

import { BaseError } from './BaseError';

export class GoogleRecaptchaExecuteError extends BaseError {
  code = ErrorCode.GOOGLE_RECAPTCHA_EXECUTE;

  constructor(message: string) {
    super(message);
  }
}
